module.exports = __webpack_public_path__ + "static/media/home__document.b6f62fe0.png";